module.exports = __webpack_public_path__ + "static/artisanflooring-c767ed24f3ab18b7511614ae8594d97b.jpg";